module.exports = __webpack_public_path__ + "static/media/social4.91705aff.svg";